var thumbnail =
webpackJsonp_name_([11],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(73);


/***/ },

/***/ 73:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(74);

/***/ },

/***/ 74:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _thumbnailControl = __webpack_require__(75);

	var _thumbnailControl2 = _interopRequireDefault(_thumbnailControl);

	var _thumbnailHeatmapOverlay = __webpack_require__(77);

	var _thumbnailHeatmapOverlay2 = _interopRequireDefault(_thumbnailHeatmapOverlay);

	var _publicApi = __webpack_require__(18);

	var _publicApi2 = _interopRequireDefault(_publicApi);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_publicApi2.default.plugins.register({
	    name: 'us:thumbnail',
	    extends: 'viewport',
	    constructor: _thumbnailControl2.default
	});

	_publicApi2.default.plugins.register({
	    name: 'us:heatmap',
	    extends: 'viewport',
	    dependency: 'us:thumbnail',
	    canStart: function canStart() {
	        return _defines2.default.supportsCanvas;
	    },

	    constructor: _thumbnailHeatmapOverlay2.default
	});

/***/ },

/***/ 75:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ThumbnailControl;

	var _lodashLite = __webpack_require__(9);

	var _ = _interopRequireWildcard(_lodashLite);

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _helpers = __webpack_require__(8);

	var _objects = __webpack_require__(7);

	var _compatibility = __webpack_require__(6);

	var _imageLoader = __webpack_require__(76);

	var _imageLoader2 = _interopRequireDefault(_imageLoader);

	var _overlays = __webpack_require__(17);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	// TODO: Move to helpers / utility

	var defaults = {
	    layout: { 'divClass': _defines2.default.clsDIVTHUMBNAIL, 'precinct': 'TR', 'order': 0 }
	};

	function ThumbnailControl(uScope, viewport) {
	    var self = this;
	    // ..... to group fns in js parser, for ease of search (e.g. search for all 'THUMB')
	    // TODO: viewfinder could be packaged into its own object
	    var THUMB = this;
	    var THUMB_VF = this;

	    var isLoaded = false; // thumbnail has been loaded
	    var coordSystem_ = _defines2.default.coordSystemNORM;

	    var jVpDiv = viewport.vpDivGet('outer');
	    var jThumbDiv;
	    var jThumbImg;
	    var jVfDiv;

	    var csThDims = new _objects.cSize(0, 0);

	    var jHoverDiv;
	    var csThDimsPreHover = new _objects.cSize(0, 0); // pre-hover thumb div size

	    var vfThread_;
	    var cpVfLT = new _objects.cPoint(0, 0);
	    var csVfDims = new _objects.cSize(0, 0);
	    var maxWidth_;

	    var cpRotOffset = new _objects.cPoint(0, 0); // thumbnail rotation offset
	    var csImgDims; //  for quick access,
	    var aspectRatio; // aspect ratio of thumbnail

	    var navModesImHiddenIn = {}; // what navigation modes not to display the label

	    var layout = _.clone(defaults.layout); // thumbnail layout info, clone the global set so I can modify it
	    var reLayout = viewport.overLayout.refreshPrecinct;

	    //............................................ specs
	    var thumbSpecs = { // thumbnail settings
	        'minWidth': 128, 'minHeight': 128, 'resizeInset': 10,
	        'scale': 0.20,
	        'minScale': 0.1, 'maxScale': 0.45
	    };
	    var vfInset = 3; // viewfinder pixel inset from edge of thumbnail

	    //............................................ prefs
	    var prefVisibleDef = true; // thumbnail visibility preference default
	    var prefThumbHoverDef = true; // thumbnail hover enlargement preference default

	    //............................................ construct_() local
	    var construct_ = function construct_() {
	        if (_defines2.default.ENABLETHUMB == false) return;
	        if (viewport.hasAThumbnail() == false) return; // if this image has no thumbnail, return
	        csImgDims = viewport.getImageDims(); // compute the viewfinder's dimensions
	        _defines2.default.setAnnotNavModes(navModesImHiddenIn); // hide thumbnail when drawing any annotation

	        load_(); // load the thumbnail
	    };

	    THUMB.events = viewport.events.$new();

	    //............................................ show() public
	    THUMB.show = function (show) {
	        if (isLoaded == false) return;
	        // prevent show if preference is not to show
	        if (uScope.prefGet(_defines2.default.clsDIVTHUMBNAIL, prefVisibleDef) == false) jThumbDiv.hide();else if (show == true) jThumbDiv.show();else jThumbDiv.hide();

	        reLayout(layout.precinct); // layout just this overlay's precinct
	    };
	    //............................................ resize() public
	    //    This function This function resizes the thumbnail.
	    //    json properties:
	    //        auto:     {true, false} indicates if this is an automatic or manual resize event
	    //        - a manual resize is called when the user resizes with the thumb's resize handle
	    //            or when in multi image and the views are rearranged
	    //        - an automatic resize is called when the browser is resized
	    THUMB.resize = function (json) {
	        if (_defines2.default.ENABLETHUMB == false || isLoaded == false) return;
	        var automatic = json.auto; // false means this resize is not from manual dragging its corner

	        var vpDivDims = viewport.vpDivDimsGet();
	        var vpWidth = vpDivDims.w,
	            vpHeight = vpDivDims.w.h;

	        maxWidth_ = Math.floor(vpWidth * thumbSpecs.maxScale); // the maximum resize width - it changes with the parent resizing

	        jThumbDiv.resizable('option', 'maxWidth', maxWidth_); // enforce the maxWidth dynamically

	        // set the thumbnail div's width
	        if (automatic == true) // when auto-resizing, keep current proportion of image/thumbnail
	            jThumbDiv.width(Math.floor(vpWidth * thumbSpecs.scale));else if (jThumbDiv.width() > maxWidth_) // if the thumbnail is sized larger than its maximum allowed - can still happen on browser resize
	            jThumbDiv.width(Math.floor(vpWidth * thumbSpecs.maxScale));else if (jThumbDiv.width() < thumbSpecs.minWidth) // if the the thumbnail is sized smaller than its minimum
	            jThumbDiv.width(thumbSpecs.minWidth);

	        jThumbDiv.height(Math.floor(jThumbDiv.width() * aspectRatio)); // set the thumbnail div's height and update its scale
	        thumbSpecs.scale = (jThumbDiv.width() / vpWidth).toFixed(2);

	        csThDims.set(jThumbDiv.width(), jThumbDiv.height()); // and save the updated thumb dims for quick access
	        jThumbImg.width(csThDims.w).height(csThDims.h); // and set the thumb image dims

	        // note: upon rotation @ the div center the div's offset is its LT corner shift
	        var angleRad = viewport.getViewAngle(); // update the angle

	        //if (us.DBGTHUMBCTL) viewport.log("thumbnail:resize: ThumbScale: " + thumbSpecs.scale + " ThumbSize: " + jThumbDiv.width() + " x" + jThumbDiv.height());

	        refreshLayout_(csThDims.w, csThDims.h, angleRad);

	        self.viewFinderRefresh('resize'); // update the viewfinder position

	        // TODO: Is the Viewport event sufficient to handle this or do we need this?
	        THUMB.events.trigger('thumbnail:resize', json);
	    };

	    //............................................ rotate() public
	    //    This function rotates the thumbnail and refreshes its position in the view
	    //    to account for the boudning box size difference due to rotation.
	    THUMB.rotate = function (angleRad) {
	        if (_defines2.default.ENABLETHUMB == false || isLoaded == false) return;
	        var thW = csThDims.w,
	            thH = csThDims.h;
	        var crBox_ = (0, _helpers.divRotate)(jThumbDiv[0], 0, 0, thW, thH, angleRad);
	        //viewport.log("thumbnail: divRotate: " + crBox_.toString());

	        //////debug
	        //    var offset = jThumbDiv.offset();                     // note: upon rotation @ the div center the div's offset is its LT corner shift
	        //    offset.x = parseInt(offset.left);
	        //    offset.y = parseInt(offset.top);
	        //    viewport.log("thumb:rotate: angle: " + Math.round(angleRad * us.Rad2Deg) + "   div offset: " + offset.x + "," + offset.y);
	        //////debug

	        cpRotOffset = refreshLayout_(thW, thH, angleRad);
	        //debug-only viewport.log("thumb:rotate: angle: " + Math.round(angleRad * us.Rad2Deg) + " THUMB  WxH: " + thW + "x" + thH + "   offset: " + cpRotOffset.x + "," + cpRotOffset.y + "   LT: " + parseInt(jThumbDiv.offset().left) + "," + parseInt(jThumbDiv.offset().top));
	    };
	    //............................................ viewFinderThread
	    var viewFinderThread = function viewFinderThread(thumbObj, bStartNow) {
	        var thisThumb = thumbObj;
	        var self = this;
	        var _viewFinderSpecs = {
	            'timerId': -1, // the view refresh timer id - note viewRefreshPrep relies on its value
	            'timerInterval': 1000 // timer interval in milliseconds
	            , viewLeft: 0, viewTop: 0, viewZoom: 0 // the view geometry that the viewfinder is outlining
	        };
	        this.setGeom = function () {
	            var cpLT = viewport.getViewLeftTop(coordSystem_);
	            _viewFinderSpecs.viewLeft = cpLT.x;
	            _viewFinderSpecs.viewTop = cpLT.y;
	            _viewFinderSpecs.viewZoom = viewport.getViewZoom();
	        };
	        var updateAction = function updateAction() {
	            if (_viewFinderSpecs.viewZoom != viewport.getViewZoom()) {
	                thisThumb.viewFinderRefresh('thread'); // size and position the thumbnail viewfinder
	                return;
	            }

	            var cpLT = viewport.getViewLeftTop(coordSystem_);
	            if (_viewFinderSpecs.viewLeft != cpLT.x || _viewFinderSpecs.viewTop != cpLT.y) {
	                thisThumb.viewFinderMove('thread'); // position the thumbnail viewfinder
	                _viewFinderSpecs.viewLeft = cpLT.x;
	                _viewFinderSpecs.viewTop = cpLT.y;
	            }
	        };
	        this.threadOn = function (option) {
	            if (option == true && _viewFinderSpecs.timerId == -1) {
	                //dbg-only     viewport.log("...viewFinderThread is ON");
	                _viewFinderSpecs.timerId = setInterval(updateAction, _viewFinderSpecs.timerInterval);
	            }
	            // TODO - verify. (cc) Original code read `_viewRefreshSpecs.timerId != -1`. _viewRefreshSpecs is defined in viewportAp
	            else if (_viewFinderSpecs.timerId != -1) {
	                    //dbg-only     viewport.log("...viewFinderThread is OFF");
	                    clearInterval(_viewFinderSpecs.timerId); // stop the view refresh timer
	                    _viewFinderSpecs.timerId = -1;
	                }
	        };
	        self.threadOn(bStartNow);
	    };

	    //............................................ viewFinderMove() public
	    //    This function positions the thumbnail's viewfinder to refect the viewport's window into the image.
	    //
	    //    parameters:
	    //        action:            the caller id used for reporting purposes

	    THUMB_VF.viewFinderMove = function (action) {
	        if (isLoaded == false) return;

	        var cpViewLT = viewport.getViewLeftTop(coordSystem_); // compute the viewfinder's left top position
	        var left = Math.floor(csThDims.w * cpViewLT.x / csImgDims.w);
	        var top = Math.floor(csThDims.h * cpViewLT.y / csImgDims.h);
	        if (cpVfLT.x == left && cpVfLT.y == top) // don't do anything if the coords have not changed
	            return;

	        if (cpVfLT.x != left || cpVfLT.y != top) {
	            // don't do anything if the coords have not changed
	            //debug-only viewport.log("      viewFinderMove(" + action + ")      view LT: " + viewport.getViewLeft() + "," + viewport.getViewTop() + " zoom: " + viewport.getViewZoom());
	            //debug-only viewport.log("      viewFinderMove(" + action + ")   VF LT: " + cpVfLT.x + "," + cpVfLT.y + "  WxH: " + csVfDims.w + "x" + csVfDims.h + "  zoom: " + viewport.getViewZoom());
	            cpVfLT.x = left;
	            cpVfLT.y = top;
	            viewFinderDraw(action);
	        }
	    };

	    //............................................ viewFinderRefresh() public
	    //    This function positions and sizes the thumbnail's viewfinder to refect the viewport's window into the image.
	    //
	    //    parameters:
	    //        action:        the caller id used for reporting purposes

	    THUMB_VF.viewFinderRefresh = function (action) {
	        if (isLoaded == false) return;
	        //debug-only viewport.log("      viewFinderRefresh(" + action + ")      view LT: " + viewport.getViewLeft() + "," + viewport.getViewTop() + " zoom: " + viewport.getViewZoom());

	        viewFinderDimsUpdate_(); // update the viewfinder's width and height
	        // compute the viewfinder's left top position
	        var cpViewLT = viewport.getViewLeftTop(coordSystem_);
	        cpVfLT.x = Math.floor(csThDims.w * cpViewLT.x / csImgDims.w);
	        cpVfLT.y = Math.floor(csThDims.h * cpViewLT.y / csImgDims.h);

	        viewFinderDraw(action);
	        return;
	        //............................................
	        // closure functions
	        //............................................ viewFinderDimsUpdate_
	        function viewFinderDimsUpdate_() {
	            var vfW = Math.floor(csThDims.w * viewport.getViewWidth() / csImgDims.w);
	            var vfH = Math.floor(csThDims.h * viewport.getViewHeight() / csImgDims.h);
	            csVfDims.set(vfW, vfH);
	        }
	        //............................................
	    };
	    //............................................ viewFinderDraw() local
	    //    This function insures the view finder rect is within the thumbnail limits, draws it
	    var viewFinderDraw = function viewFinderDraw(action) {
	        var left = cpVfLT.x,
	            top = cpVfLT.y,
	            width = csVfDims.w,
	            height = csVfDims.h;

	        if (left < vfInset) {
	            // constrain the viewfinder inside the thumbnail
	            width = width + left - vfInset - 1;
	            left = vfInset;
	        }

	        if (top < vfInset) {
	            height = height + top - vfInset - 1;
	            top = vfInset;
	        }
	        //if (us.DBGTHUMBVFCTL) viewport.log("ThumbViewFinder (unconstrained): XY(" + left + "," + top + ")  WH:(" + width + "x" + height + ")");

	        width = (0, _helpers.limitValue)(width, vfInset, csThDims.w - vfInset - left - 1);
	        height = (0, _helpers.limitValue)(height, vfInset, csThDims.h - vfInset - top - 1);
	        //if (us.DBGTHUMBVFCTL)  viewport.log("ThumbViewFinder (constrained): XY(" + left + "," + top + ")  WH:(" + width + "x" + height + ")");

	        if (_compatibility.BrowserDetect.isIE()) // update the viewfinder div's position and size
	            jVfDiv.css({
	                'left': left - 4 + 'px',
	                'top': top - 4 + 'px',
	                'width': width + 4 + 'px',
	                'height': height + 4 + 'px'
	            });else jVfDiv.css({ 'left': left + 'px', 'top': top + 'px', 'width': width + 'px', 'height': height + 'px' });

	        vfThread_.setGeom();

	        // if thisImage is a control unless it is raster scanning, do not draw on the heatmap
	        if (viewport.sampleTypeIsControl() == true && viewport.navModeGet() != _defines2.default.eNavModes.nmRasterScan) return;

	        THUMB.events.trigger('thumbnail:viewfinder:draw', action, cpVfLT, csVfDims);
	    };
	    //............................................ getThumbScale() local
	    THUMB.getThumbScale = function () {
	        var scaleX = csThDims.w / csImgDims.w;
	        var scaleY = csThDims.h / csImgDims.h;
	        ///viewport.log("thumbnail scale: x: " + scaleX + "   y:" + scaleY);
	        return scaleX;
	    };
	    //............................................ dimensionsGet() local
	    THUMB.dimensionsGet = function () {
	        return new _objects.cSize(csThDims.w, csThDims.h);
	    };

	    //............................................ load_() local
	    //    This function creates the thumbnail image div and loads it with the thumbnail.
	    //    When the image loaded it calls into the layout manager to position the thumbnail according
	    //    to its layout settings and adds the thumbnail viewfinder element
	    var load_ = function load_() {
	        if (jThumbDiv) return; // if this viewport already has a thumbnail, return

	        // first create an offscreen div that will contain the Thumbnail img and add it to the vp
	        jThumbDiv = $('<div/>', { // build the div tag that contains the img tag
	            'class': _defines2.default.clsDIVTHUMBNAIL + ' ' + _defines2.default.clsOVERLAY, // overlay class sets the z-index
	            css: { 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX, 'overflow': 'hidden' }
	        });

	        // Expose the container for thumbnail overlay access (such as the heatmap)
	        THUMB.$container = jThumbDiv;

	        if (_defines2.default.ENABLETHUMBHOVER == true) {
	            // build the div tag that evokes the hover to enlarge the thumbnail action
	            jHoverDiv = $('<div/>', { 'class': _defines2.default.clsDIVTHUMBHOVER + ' ' + _defines2.default.clsSUPEROVERLAY });
	            jThumbDiv.append(jHoverDiv);
	        }

	        jVpDiv.append(jThumbDiv); // place the thumb div in its viewport
	        jThumbDiv = jVpDiv.find('.' + _defines2.default.clsDIVTHUMBNAIL);
	        //if (us.DBGTHUMBCTL) viewport.log("thumbnail:load: Thumbnail div appended to viewport(" + viewport.getImageId() + ")");

	        // next build the image tag and load the thumbnail image
	        thumbSpecs.scale = _compatibility.BrowserDetect.isIOS() ? 0.3 : thumbSpecs.scale; //IOS requires a larger thumbnail
	        var width = Math.floor(jVpDiv.width() * 0.5); // the requested thumbnail width

	        var sThumbImgSrc = viewport.urlBuilder.thumb(width, 0);
	        // if (us.DBGTHUMBCTL) viewport.log("thumbnail:load: src: " + sThumbImgSrc); // /imageserver/@2?0+0+435+0+-1

	        (0, _imageLoader2.default)(sThumbImgSrc, {
	            className: _defines2.default.clsIMGTHUMBNAIL,
	            alt: ''
	        }).then(function (image) {
	            // check that this viewport's imageId === this image source's imageId
	            var srcId = (0, _overlays.getImageIdFromSrcAttr)(image); // format "@2"
	            if (viewport.getImageId() !== srcId) {
	                // if they don't match, do not load this thumbnaail (async return from another image!)
	                viewport.log('...thumbnail:load: vpDiv id=' + viewport.getImageId() + '  srcId=' + srcId + ' - skipping load!!');
	                return;
	            }
	            if (isLoaded) {
	                // don't load the same thumbnail multiple times (happens when VIL reopens same image)
	                viewport.log('...thumbnail:load: Thumbnail image for (' + viewport.getImageId() + ') received again!!');
	                return;
	            }
	            isLoaded = true;

	            //if (us.DBGTHUMBCTL) viewport.log("thumbnail:load: Thumbnail image loaded(" + viewport.getImageId() + ")");

	            // now the requested thumbnail is larger than the initial div it is displayed in so the div and the image must be resized
	            //    - this is done so that when thumbnail is resized it isn't pixelated
	            var csThumbnail = viewport.getThumbFileDims(); // get the initial width of the thumbnail div

	            var vpDivDims = viewport.vpDivDimsGet();
	            var vpW = vpDivDims.w,
	                vpH = vpDivDims.h;

	            var thW = Math.floor(vpW * thumbSpecs.scale);
	            var thH = Math.floor(thW * csThumbnail.h / csThumbnail.w);

	            if (thH / vpH > thumbSpecs.maxScale) {
	                // if this width-based scaling makes the th height too big
	                thH = Math.floor(vpH * thumbSpecs.maxScale);
	                thW = Math.floor(thH * csThumbnail.w / csThumbnail.h);
	                thumbSpecs.scale = (thW / vpW).toFixed(2);
	            } else if (thH / vpH < thumbSpecs.minScale) {
	                // if this width-based scaling makes the th height too small
	                thumbSpecs.scale = thumbSpecs.maxScale;
	                thW = Math.floor(vpW * thumbSpecs.scale);
	                thH = Math.floor(thW * csThumbnail.h / csThumbnail.w);
	            }
	            aspectRatio = thH / thW; // save the aspect ratio of thumbnail
	            jThumbDiv.width(thW).height(thH);
	            csThDims.set(thW, thH); // save updated thumb dims for quick access
	            csThDimsPreHover.setSize(csThDims); // save pre-hover size of thumbnail

	            jThumbDiv.append(image); // place the thumbnailImg in the DOM's thumb div in the viewport
	            jThumbImg = jThumbDiv.find('.' + _defines2.default.clsIMGTHUMBNAIL);
	            jThumbImg.width(thW).height(thH); // now set the thumbnail image dimensions to that of its div
	            if (_defines2.default.DBGTHUMBCTL) viewport.log('thumbnail:load_: ThumbScale: ' + thumbSpecs.scale + ' ThumbSize: ' + jThumbDiv.width() + ' x' + jThumbDiv.height());

	            viewport.overLayout.add(layout); // and call into layout with parms to place the div

	            viewFinderLoad_(); // and add the thumbnail's viewfinder rect

	            // TODO: Trigger load and just do what you need to there.
	            self.resize({ auto: true }); // resize to set the thumbnail size
	            self.show(true); // show/hide according to user preferences

	            if (viewport.getViewAngle() != 0.0) {
	                self.rotate(viewport.getViewAngle());
	            }

	            THUMB.events.trigger('thumbnail:thumbnail-loaded');
	        }).catch(function (e) {
	            viewport.log('thumbnail: load: error');
	        });

	        bindEvents_(); // add event handlers

	        //..................................................
	        // closure functions
	        //............................................ bindEvents_()
	        // bindEvents_ - This function adds the thumbnail event handlers.
	        //
	        //    Note that by using the same namespace as the viewport when the
	        //    viewport removes its events by namespace, these are also removed.
	        function bindEvents_() {
	            var namespace = viewport.eventNameSpaceGet();

	            // show/hide thumbnail on mode change
	            $(_defines2.default.idHashROOT).on(_defines2.default.evMODECHANGE + namespace, function (e, parms) {
	                // show is true if this is the image selected and not in a mode that I'm supposed to hide during
	                var bshow = !!(viewport.getImageIdx() == uScope.getSelImageIdx() && navModesImHiddenIn[parms.navMode] == undefined);
	                self.show(bshow);
	                self.viewFinderRefresh('mode change');
	            });

	            // show/hide thumbnail if image is a control sample
	            $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
	                //debug-only viewport.log("thumbnail: selected: call to show: " + (parms.uScopeIdx == viewport.getImageIdx()));
	                self.show(parms.uScopeIdx == viewport.getImageIdx());
	            });

	            //............................................ user preference update
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSREADY + namespace, function (e, parms) {
	                //debug-only viewport.log("Thumbnail us.evUSERPREFSREADY recvd");
	                self.show(uScope.prefGet(_defines2.default.clsDIVTHUMBNAIL));
	            });

	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSET + namespace, function (e, parms) {
	                // parms: {className: STR, value: bool}
	                if (parms.className == _defines2.default.clsDIVTHUMBNAIL) {
	                    //viewport.log("Thumbnail us.evUSERPREFSET recvd: for " + parms.className + " set to: " + parms.value);
	                    self.show(parms.value);
	                } else if (parms.className == _defines2.default.CVSHEATMAP && parms.value == true && uScope.prefGet(_defines2.default.clsDIVTHUMBNAIL) == false) {
	                    uScope.visibilityPanel.check(_defines2.default.clsDIVTHUMBNAIL, true);
	                    // viewport.log("Thumbnail us.evUSERPREFSET recvd: for " + parms.className + " so I'm displaying the thumbnail");
	                }
	            });

	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFDEFAULTVISIBLE + namespace, function (e, parms) {
	                //viewport.log("Thumbnail us.evUSERPREFDEFAULTVISIBLE recvd");
	                uScope.prefSet(_defines2.default.clsDIVTHUMBNAIL, prefVisibleDef);
	            });

	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFDEFAULTTHUMBHOVER + namespace, function (e, parms) {
	                //viewport.log("Thumbnail us.evUSERPREFDEFAULTTHUMBHOVER recvd");
	                uScope.prefSet(_defines2.default.clsDIVTHUMBHOVER, prefThumbHoverDef);
	            });

	            //............................................ hover over thumb action
	            if (_defines2.default.ENABLETHUMBHOVER == true) {
	                //..................................................
	                // closure functions
	                var hoverThumbTimerRemove_ = function hoverThumbTimerRemove_() {
	                    var timer = jThumbDiv.data('hover');
	                    if (timer) {
	                        clearTimeout(timer); // stop the timer
	                        jThumbDiv.data('hover', null); // remove the  timer in the thumb div data
	                    }
	                };
	                var resizeTo = function resizeTo(width) {
	                    jThumbDiv.width(width);
	                    self.resize({ auto: false });
	                };
	                //..................................................
	                // hover event related
	                jHoverDiv.hover( // enlarge the thumbnail on hover
	                function (e) {
	                    if (!uScope.prefGet(_defines2.default.clsDIVTHUMBHOVER, prefThumbHoverDef)) {
	                        return;
	                    }

	                    var timer = jThumbDiv.data('hover'); // show the panel when the mouse hovers over the toolbar icon
	                    var hoverOn = jThumbDiv.data('hoverOn');

	                    if (!hoverOn && !timer && csThDims.w < maxWidth_ * 0.75) {
	                        // if no timer set and the thumbnail size is not already large
	                        timer = setTimeout(function () {
	                            // then set timer that will fire the hover action after 2 seconds
	                            csThDimsPreHover.setSize(csThDims); // save pre-hover size of thumbnail
	                            resizeTo(csThDims.w * 1.5); // enlarge the thumbnail
	                            jThumbDiv.data('hoverOn', true); // flag that hover enlargement is on
	                            hoverThumbTimerRemove_(); // and remove the timer
	                            //self.log("jHoverDiv.hover  resize to: " + parseInt(csThDims.w * 1.5));
	                        }, 150); // delay time in milli-sec (this actually takes a lot longer)
	                        jThumbDiv.data('hover', timer); // save timer in the thumb div data
	                    }
	                }, function () {
	                    // handler out
	                    hoverThumbTimerRemove_();
	                });
	                jThumbDiv.on('mouseleave' + namespace, function () {
	                    // return the thumbnail size back to its pre-hover size
	                    if (uScope.prefGet(_defines2.default.clsDIVTHUMBHOVER, prefThumbHoverDef) == false) // check if pref enables hover action
	                        return;

	                    resizeTo(csThDimsPreHover.w); // return the thumbnail to its pre-hover size
	                    jThumbDiv.data('hoverOn', false); // flag that hover enlargement is off
	                    hoverThumbTimerRemove_(); // remove the timer
	                    //self.log("jThumbDiv mouseleave  resize to: " + csThDimsPreHover.w);
	                    return false;
	                });
	            }

	            //............................................ resize, click, mouse, ...
	            if (layout.precinct == 'BR') {
	                jThumbDiv.resizable({
	                    cursor: 'move', handles: 'nw', aspectRatio: true, distance: 3, minWidth: thumbSpecs.minWidth

	                    //debug-only, start: function (e, ui) { viewport.log("Started thumbnail resizing!"); }
	                    //debug-only, stop: function (e, ui) { viewport.log("Stopped thumbnail resizing!"); }
	                    , start: function start(e, ui) {
	                        //viewport.log("thumb resizable start");
	                        e.preventDefault();
	                        return false;
	                    },
	                    resize: function resize(e, ui) {
	                        self.resize({ auto: false });
	                        csThDimsPreHover.setSize(csThDims); // save pre-hover size of thumbnail
	                        jThumbDiv.data('hoverOn', false); // flag that hover enlargement is off
	                        e.preventDefault();
	                        return false;
	                    },
	                    stop: function stop(e, ui) {
	                        //viewport.log("thumb resizable STOP");
	                        e.preventDefault();
	                        return false;
	                    }
	                });
	            } else {
	                jThumbDiv.resizable({
	                    cursor: 'move', handles: 'sw', aspectRatio: true, distance: 3, minWidth: thumbSpecs.minWidth,
	                    start: function start(e, ui) {
	                        //viewport.log("thumb resizable start");
	                        e.preventDefault();
	                        return false;
	                    },
	                    resize: function resize(e, ui) {
	                        self.resize({ auto: false });
	                        csThDimsPreHover.setSize(csThDims); // save pre-hover size of thumbnail
	                        jThumbDiv.data('hoverOn', false); // flag that hover enlargement is off

	                        //viewport.log("thumb resizable: " + csThDimsPreHover);
	                        e.preventDefault();
	                        return false;
	                    },
	                    stop: function stop(e, ui) {
	                        //viewport.log("thumb resizable STOP: " + csThDimsPreHover);
	                        e.preventDefault();
	                        return false;
	                    }
	                });
	            }

	            jThumbDiv.on('mousedown' + namespace, function (e) {
	                viewport.setImageSelected(); // inform uScope that this image is in focus
	                //debug-only viewport.log("- thumbnail mousedown!");

	                // ios tap never sends thumb up to switch out of thumb drag mode //cp-test if this is still necessary
	                if (viewport.navModeGet() == _defines2.default.eNavModes.nmThumbDragImage) _defines2.default.navModeHalt(viewport);
	                // if no current navigation is happening then move the image via click on thumbnail
	                //    - move on viewport onto thumbnail prevent odd behavior
	                if (viewport.navModeGet() == _defines2.default.eNavModes.nmNone) {
	                    var cpThPos = withinInset_(e);
	                    if (cpThPos != false) {
	                        // if not on the very edge of the thumbnail
	                        viewport.navMode = _defines2.default.eNavModes.nmThumbDragImage; // anticipate thumb drag mode
	                        navEvent_(e); // move the view
	                    }
	                } else {
	                    if (_defines2.default.DBGTHUMBCTL) viewport.log('... th_mousedown: ignored - nav mode != none');
	                }
	                //e.preventDefault(); // to prevent the grab and drag of the thumbnail
	                return false; // prevent propigation to VP
	            });
	            jThumbDiv.on('mousemove' + namespace, function (e) {
	                //viewport.log("- - thumbnail mousemove!");
	                if (viewport.navModeGet() == _defines2.default.eNavModes.nmThumbDragImage) {
	                    // if dragging viewfinder around the thumbnail
	                    var cpThPos = withinInset_(e);
	                    if (cpThPos != false) {
	                        // if not on the very edge of the thumbnail
	                        navEvent_(e); // move the view
	                    }
	                } else {
	                    if (_defines2.default.DBGTHUMBCTL) viewport.log('... th_mousemove: ignored - nav mode != ' + _defines2.default.eNavModes.nmThumbDragImage);
	                }
	                return true; // propigate necessary or thumb resize does not reduce in size
	            });
	            jThumbDiv.on('mouseup' + namespace + ' focus' + namespace, function (e) {
	                // stops drag in viewport from continuing
	                //viewport.log("- - - thumbnail mouseup!");
	                // note that almost always the thumbnail mouse up event is caught in vp_mouseup and handled there
	                if (viewport.navModeGet() !== _defines2.default.eNavModes.nmAutoPan) // mouse up means end of navigation mode unless autopan
	                    _defines2.default.navModeHalt(viewport);
	                return true; // propigate necessary or thumb resize does not release
	            });
	            jThumbDiv.on('dblclick' + namespace, function (e) {
	                //viewport.log("- thumbnail double click!");
	                return false; // prevent dblclick on thumbnail causing double click zoom on viewport
	            });
	            viewport.events.on('viewport:resize', function (autoThumbResize) {
	                self.resize({ auto: autoThumbResize });
	            });
	            viewport.events.on('viewport:rotate', function (angleRad) {
	                self.rotate(angleRad);
	            });
	        }
	        //............................................
	        // closure functions
	        //............................................ navEvent_
	        //    This function This function moves the view to the image position indicated by the event on the thumbnail.
	        function navEvent_(e) {
	            var cpThPos = coordPageToThumb_(e); // mouse position wrt top/left of thumbnail
	            var cpBaseCoord = coordBaseImage_(cpThPos); // get this position in base coords

	            //debug-only viewport.log("thumbnail:navEvent_: cpThLTcpThPos " + cpThPos.toString() + "  translated: " + cpBaseCoord.toString());
	            //if (us.DBGTHUMBCTL) viewport.log("... navEvent_: nav mode = drag, new base coord = " + cpBaseCoord.toString());

	            viewport.moveAbsolute(cpBaseCoord.x, cpBaseCoord.y, coordSystem_);
	            viewport.setMouseDown(cpBaseCoord.x, cpBaseCoord.y); // note: does not use constrained positions that above call may have enforced!!
	            viewport.setMouseCur(cpBaseCoord.x, cpBaseCoord.y);

	            self.viewFinderMove('navevent'); // position the thumbnail viewfinder
	        }
	        //............................................ withinInset_
	        //    This function determines if an event's page coords are within the thumbnail by the specified inset (margin).
	        //    Passed Parameters: event
	        //    Returns a cPoint of the cursor position within the thumbnail or false if cursor position isn't within the inset
	        function withinInset_(e) {
	            var cpThPos = coordPageToThumb_(e); // get cursor position inside this element

	            var inset = thumbSpecs.resizeInset || 10;
	            if (cpThPos.x < inset || cpThPos.y < inset) {
	                //if (us.DBGTHUMBCTL) viewport.log("thumbnail:withinInset_: too close to top/left: " + cpThPos.toString());
	                return false;
	            }

	            if (cpThPos.x > jThumbDiv.width() - inset || cpThPos.y > jThumbDiv.height() - inset) {
	                //if (us.DBGTHUMBCTL) viewport.log("thumbnail:withinInset_: too close to bottom/right: " + cpThPos.toString());
	                return false;
	            }
	            return cpThPos;
	        }
	        //............................................
	    };
	    //............................................ viewFinderLoad_() local
	    //    This function This function creates the div for the thumbnail's viewfinder and appends
	    //    it to the thumbnail div then calls for the viewfinder to be positioned to indicate
	    //    the viewport's window into the image.
	    var viewFinderLoad_ = function viewFinderLoad_() {
	        if (isLoaded == false) return;

	        var vfW = Math.floor(jThumbDiv.attr('offsetWidth') / 4); // default view finder dimensions
	        var vfH = Math.floor(jThumbDiv.attr('offsetHeight') / 4); //  - to be replaced when vf is positioned

	        jVfDiv = $('<div/>', { // build the div tag that contains the viewfinder
	            'class': _defines2.default.clsDIVVIEWFINDER + ' ' + _defines2.default.clsSUPEROVERLAY,
	            css: {
	                'left': '0px', 'top': '0px', 'width': vfW, 'height': vfH,
	                'overflow': 'auto', // necessary for IE
	                'border-color': viewport.getCaptureType() == _defines2.default.eAICCaptureType.aic_i_FL ? '#FFFFFF' : '#000000',
	                'outline-color': viewport.getCaptureType() == _defines2.default.eAICCaptureType.aic_i_FL ? '#000000' : '#FFFFFF'
	            }
	        });
	        if (_compatibility.BrowserDetect.isIE()) jVfDiv.css({ 'outline-width': '0' });

	        jThumbDiv.append(jVfDiv); // and add it to the thumbnail div
	        jVfDiv = jVpDiv.find('.' + _defines2.default.clsDIVVIEWFINDER);

	        if (_defines2.default.DBGTHUMBVFCTL) viewport.log('thumbnail: viewFinderLoad_: appended to thumbnail(' + viewport.getImageId() + ')');

	        ///viewFinderThreadOn(true);
	        vfThread_ = new viewFinderThread(self, true);
	        //should just do this in thread start
	        self.viewFinderRefresh('load'); // now position the view finder to indicate the viewport
	    };

	    //............................................ refreshLayout_() local
	    //    This function computes the thumbnail's rotation offset and refreshes its layout.
	    //    note: upon rotation @ the div center the div's offset is its LT corner shift
	    var refreshLayout_ = function refreshLayout_(thW, thH, angleRad) {
	        cpRotOffset = (0, _helpers.computeRotationOffset)(thW, thH, angleRad); // compute and save the rotation offset in member var
	        //viewport.log("thumbnail: refreshLayout_: rotOffset: " + cpRotOffset.toString());

	        layout.rightOffset = -cpRotOffset.x; // update the thumbnail layout info for the the rotation offset
	        layout.bottomOffset = -cpRotOffset.y; // bc layout obj holds a ref to the var layout, its refresh picks up the change

	        reLayout(layout.precinct); // layout just this overlay's precinct
	        return cpRotOffset;
	    };

	    //............................................ coordPageToThumb_() local
	    //    This function determines the cursor position relative to (within) the thumbnail
	    //                        as if it was not rotated.
	    //    Passed Parameters:
	    //                event object
	    //    Returns:
	    //                a cPoint of the cursor position within the unrotated thumbnail
	    var coordPageToThumb_ = function coordPageToThumb_(e) {
	        var cpRtn = new _objects.cPoint(0, 0); // return position object

	        var tgtOff = jThumbDiv.offset(); // the current position of the target relative to the document
	        var thX = e.pageX - tgtOff.left; // translate thumbnail left top position
	        var thY = e.pageY - tgtOff.top;
	        var cpRtn = coordUnRotate_(thX, thY); // un-rotate the thumbnail coordinate

	        cpRtn.x = (0, _helpers.limitValue)(cpRtn.x, 0, csThDims.w - 1); // insure the coords are within limits
	        cpRtn.y = (0, _helpers.limitValue)(cpRtn.y, 0, csThDims.h - 1);
	        //if (us.DBGTHUMBCTL) viewport.log("thumbnail:coordPageToThumb_ (" + cpRtn.x + "," + cpRtn.y + ")");
	        return cpRtn;
	    };
	    //............................................ coordUnRotate_() local
	    //    This function converts rotated thumbnail coords to un-rotated thumb coords.
	    //    Passed Parameters:
	    //        thX, thY:    [rotated] thumbnail relative x,y pixel position
	    //    Returns:
	    //        cPoint object with un-rotated thumbnail relative x,y pixel position

	    var coordUnRotate_ = function coordUnRotate_(thX, thY) {
	        //debug-only viewport.log("thUnRotateCoord input => (" + pageX + "," + pageY + ")");
	        var cpRtn = new _objects.cPoint(thX, thY); // return position object
	        var imgRotAngleRad = viewport.getViewAngle();
	        if (imgRotAngleRad != 0) {
	            var ptx = thX + cpRotOffset.x,
	                pty = thY + cpRotOffset.y;
	            var xc = csThDims.w / 2,
	                yc = csThDims.h / 2; // Thumbnail center position

	            var dx = ptx - xc,
	                dy = yc - pty; // Transform Point Coordinates to Thumbnail center (xc,yc)
	            var hyp = Math.sqrt(dx * dx + dy * dy); //    Hypotenuse
	            var thetaRad = Math.atan2(dy, dx); // Transformed Point Angle

	            var phiRad = thetaRad + imgRotAngleRad; // Add Rotation to Point Angle
	            cpRtn.x = hyp * Math.cos(phiRad); // Compute Shift
	            cpRtn.y = hyp * Math.sin(phiRad);

	            //debug-only viewport.log("........Rotate => (" + parseInt(cpRtn.x) + "," + parseInt(cpRtn.y) + ")");
	            var xi = cpRtn.x + xc,
	                yi = yc - cpRtn.y; // compute x-shift and convert to image coordiantes
	            cpRtn.x = Math.round(xi);
	            cpRtn.y = Math.round(yi);
	            //debug-only viewport.log(".................thUnRotateCoord xi,yi => (" + cpRtn.x + "," + cpRtn.y + ")");
	        }
	        return cpRtn;
	    };
	    //............................................ coordBaseImage_() local
	    //    This function returns the base image coordinate corresponding to a pixel position on the thumbnail.
	    //    input unrotated thumbnail click point (must be inside thumbnail) returns a cPoint of .....
	    var coordBaseImage_ = function coordBaseImage_(cpThumb) {
	        var cpRtn = new _objects.cPoint(-1, -1); // return position object
	        if (_defines2.default.DBGTHUMBCTL) viewport.log('thumbPosition (' + cpThumb.x + ',' + cpThumb.y + ')');

	        var imageWidth = viewport.getImageWidth();
	        var viewZoom = viewport.getViewZoom();

	        var vpDivDims = viewport.vpDivDimsGet();
	        var vpWidth = vpDivDims.w,
	            vpHeight = vpDivDims.h;

	        var thumbZoom = imageWidth / csThDims.w;
	        // compute the mouse position in base image coords
	        cpRtn.x = Math.floor(thumbZoom * cpThumb.x - vpWidth * viewZoom / 2);
	        cpRtn.y = Math.floor(thumbZoom * cpThumb.y - vpHeight * viewZoom / 2);
	        return cpRtn; // and return it
	    };

	    construct_();
	}
	module.exports = exports['default'];

/***/ },

/***/ 76:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _lodashLite = __webpack_require__(9);

	var _ = _interopRequireWildcard(_lodashLite);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	exports.default = function (src, options) {
	    return new Promise(function (resolve, reject) {
	        var loader = new Image();

	        _.assign(loader, options);

	        loader.onload = function () {
	            resolve(loader);
	        };
	        loader.onerror = function (err) {
	            reject(new Error(err));
	        };

	        loader.crossOrigin = 'anonymous';
	        loader.src = src;
	    });
	};

	module.exports = exports['default'];

/***/ },

/***/ 77:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ThumbnailHeatMapOverlay;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _compatibility = __webpack_require__(6);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// us.ENABLEHEATMAP is set true/false via VILSettings.
	//    If it is false at that time, the switch    to enable/disable it IS NOT displayed in settings/visibility
	//        and the drawing functions return without drawing.
	//    If it is true at that time, the switch to enable/disable it IS displayed in settings/visibility
	//        and the drawing functions obey the visibility setting.
	//
	//    This object uses HTML5 canvas.  IF the browser is not canvas-able, it disables itself.
	//    canvas references:
	//        http://www.w3schools.com/tags/ref_canvas.asp
	//
	//
	//    improvements:
	//    - perhaps alpha is set according to the view mag so smaller views are easier to distinguish
	//    - browser resize clears the heatmap even when it is not resized for unknown reasons

	function ThumbnailHeatMapOverlay(uScope, viewport, thumbnailControl) {
	    var self = this;
	    var jThumbDiv = thumbnailControl.$container;
	    var isLoaded = false; // heatmap has been loaded

	    var jHeatMap;
	    var heatMapId; // heatmap canvas tag id
	    var pHMCanvas; // canvas
	    var pHMContext; // context

	    var alphaDef = 0.3; // default alpha

	    //............................................ prefs
	    var prefVisibleDef = true; // thumbnail heatmap visibility preference default

	    //............................................ resize() public
	    this.resize = function () {
	        if (isLoaded == false) return;
	        //Note: resetting because browser resize does not retain heatmap
	        if (pHMContext) {
	            if (pHMCanvas.width == jThumbDiv.width() && pHMCanvas.height == jThumbDiv.height()) return;
	            //debug-only viewport.log("cThumbHeatMap:resize: from: " + pHMCanvas.width + "x" + pHMCanvas.height + "  to: " + jThumbDiv.width() + "x" + jThumbDiv.height());

	            var data = pHMCanvas.toDataURL(); // save the canvas content as imageURL

	            pHMCanvas.width = jThumbDiv.width(); // resize the canvas which clears its context
	            pHMCanvas.height = jThumbDiv.height();

	            var self = this; // save the local context for use in onload callback
	            var img = new Image(); // scale and redraw the canvas content

	            // Wait for image to load. In some circumstances, the image may not be ready immediately
	            // use img.onload (all lowercase) or img.addEventListener('load', function () {}), not img.onLoad !!! Case matters!
	            img.onload = function () {
	                pHMContext.drawImage(img, 0, 0, img.width, img.height, 0, 0, pHMCanvas.width, pHMCanvas.height);
	                self.contextDefault(); // restore the cleared canvas context to its default values
	            };

	            img.onerror = function (err) {
	                viewport.err('cThumbHeatMap: resize: loading image at ' + img.src, err);
	            };

	            img.src = data; // start loading the image
	        }
	    };

	    //............................................ settings fns public
	    this.alphaSet = function (alpha) {
	        if (pHMContext) pHMContext.globalAlpha = alpha;
	    }; // s/b between 0 and 1.0
	    this.fillColorSet = function (color) {
	        if (pHMContext) pHMContext.fillStyle = color;
	    };
	    this.fillColorGet = function () {
	        return pHMContext ? pHMContext.fillStyle : '#000000';
	    };
	    this.strokeColorSet = function (color) {
	        if (pHMContext) pHMContext.strokeStyle = color;
	    };
	    this.strokeColorGet = function () {
	        return pHMContext ? pHMContext.strokeStyle : '#000000';
	    };

	    //............................................ contextDefault() public
	    this.contextDefault = function () {
	        if (isLoaded == false) return;
	        if (pHMContext) {
	            this.alphaSet(alphaDef);
	            var color = _defines2.default.objectiveColor(viewport.getViewMag());
	            this.fillColorSet(color);
	            this.strokeColorSet(color);

	            pHMContext.globalCompositeOperation = 'source-over';
	        }
	    };
	    //............................................ rectFill() public
	    var hmc = 0;
	    this.rectFill = function (x, y, w, h, opt_alpha, opt_color) {
	        if (_defines2.default.ENABLEHEATMAP == false) return; // live switch
	        if (isLoaded == false) return;
	        //viewport.log((++hmc) + ' heatmap: rectFill: X,Y: ' + x +','+ y + '  WxH: ' + w+',' + h);//////////////
	        if (pHMContext) {
	            pHMContext.save();
	            pHMContext.beginPath();

	            if (opt_alpha) this.alphaSet(opt_alpha);
	            if (opt_color) this.fillColorSet(opt_color);
	            pHMContext.rect(x, y, w, h);
	            pHMContext.fill();

	            pHMContext.restore();
	            //viewport.log("thumb heatMap: rectFill: L,T: " + x + "," + y + "  WxH: " + w + "x" + h);
	        }
	    };
	    //............................................ drawRect() public
	    this.drawRect = function (x, y, w, h, opt_alpha, opt_color) {
	        if (_defines2.default.ENABLEHEATMAP == false) return; //live switch
	        if (isLoaded == false) return;
	        if (pHMContext) {
	            pHMContext.save();

	            pHMContext.beginPath();
	            if (opt_alpha) this.alphaSet(opt_alpha);
	            //why not             pHMContext.globalAlpha = 0.2;
	            if (opt_color) this.strokeColorSet(opt_color);

	            pHMContext.rect(x, y, w, h);
	            pHMContext.stroke();

	            pHMContext.restore();
	            //viewport.log("thumb heatMap: drawRect: L,T: " + x + "," + y + "  WxH: " + w + "x" + h);
	        }
	    };
	    //............................................ drawPixels() public
	    this.drawPixels = function (pixelList, hexColor, opt_doDouble) {
	        if (_defines2.default.ENABLEHEATMAP == false) return; // live switch
	        if (isLoaded == false) return;
	        if (pHMContext) {

	            var color = parseInt(hexColor.substr(1), 16);
	            var blue = color & 0xFF;
	            var green = color >> 8 & 0xFF;
	            var red = color >> 16 & 0xFF;

	            var canvasWidth = pHMCanvas.width;
	            var canvasData = pHMContext.getImageData(0, 0, canvasWidth, pHMCanvas.height);

	            for (var i = 0, len = pixelList.length; i < len; i++) {
	                var pt = pixelList[i];
	                var index = (pt.x + pt.y * canvasWidth) * 4;

	                canvasData.data[index] = red;
	                canvasData.data[index + 1] = green;
	                canvasData.data[index + 2] = blue;
	                canvasData.data[index + 3] = 255; // important to set alpha

	                if (opt_doDouble == true) {
	                    // if parms says to double the pt
	                    index += 4;
	                    canvasData.data[index] = red;
	                    canvasData.data[index + 1] = green;
	                    canvasData.data[index + 2] = blue;
	                    canvasData.data[index + 3] = 255; // important to set alpha
	                    index += canvasWidth * 4;
	                    canvasData.data[index] = red;
	                    canvasData.data[index + 1] = green;
	                    canvasData.data[index + 2] = blue;
	                    canvasData.data[index + 3] = 255; // important to set alpha
	                    index -= 4;
	                    canvasData.data[index] = red;
	                    canvasData.data[index + 1] = green;
	                    canvasData.data[index + 2] = blue;
	                    canvasData.data[index + 3] = 255; // important to set alpha
	                }
	            }

	            pHMContext.putImageData(canvasData, 0, 0);
	        }
	    };
	    //............................................ erase() public
	    this.erase = function () {
	        if (isLoaded == false) return;
	        if (pHMContext) pHMContext.clearRect(0, 0, pHMCanvas.width, pHMCanvas.height);
	    };

	    //............................................ construct_()
	    function construct_() {
	        if (_defines2.default.ENABLEHEATMAP == false) return;
	        if (_defines2.default.supportsCanvas == false) return; // insure a heat map can be created and is enabled

	        if (uScope.isThisImageIdValid(viewport.getImageId()) == false) {
	            // protect against rapid slide changes that closes images
	            viewport.err('heatmap: load_: image is not loaded');
	            _defines2.default.ENABLEHEATMAP = false;
	            return;
	        }

	        var vpclassid = _defines2.default.classFromImageId(viewport.getImageId()); // convert the imageId into a class name
	        heatMapId = _defines2.default.CVSHEATMAP + '_' + vpclassid;

	        jHeatMap = $('<canvas/>', { 'id': heatMapId, 'class': _defines2.default.CVSHEATMAP + ' ' + _defines2.default.clsOVERLAY });
	        jThumbDiv.append(jHeatMap); // and add it to the thumbnail div
	        jHeatMap = jThumbDiv.find('#' + heatMapId);

	        pHMCanvas = document.getElementById(heatMapId);
	        if (pHMCanvas == undefined || pHMCanvas == null) {
	            // protect against rapid slide close/open sequence that removes elements
	            viewport.err('heatmap: load: image canvas is not present: ' + heatMapId);
	            return;
	        }
	        pHMContext = pHMCanvas.getContext('2d');

	        isLoaded = true;

	        pHMCanvas.width = jThumbDiv.width(); // set canvas dims
	        pHMCanvas.height = jThumbDiv.height();
	        self.contextDefault(); // context default settings

	        bindEvents_(); // add event handlers
	        // note! this cures a race condition: because of late load of hm, us.evUSERPREFSREADY has already been fired, so get the user pref now
	        _defines2.default.ENABLEHEATMAP = uScope.prefGet(_defines2.default.CVSHEATMAP);
	    }

	    // bindEvents_ - This function adds the heatmap event handlers.
	    //
	    //    Note that by using the same namespace as the viewport when the
	    //    viewport removes its events by namespace, these are also removed.
	    function bindEvents_() {
	        var namespace = viewport.eventNameSpaceGet();
	        thumbnailControl.events.on('thumbnail:resize', function () {
	            self.resize();
	        });
	        thumbnailControl.events.on('thumbnail:viewfinder:draw', function (action, position, size) {
	            // highlights the current view on the heat map
	            if (action !== 'resize' && !viewport.isFitZoom()) {
	                var left = position.x;
	                var top = position.y;
	                var width = size.w;
	                var height = size.h;

	                if (_compatibility.BrowserDetect.isIE()) {
	                    // px adjustments b/c of border&outline
	                    self.rectFill(left - 2, top - 2, width + 4, height + 4);
	                } else {
	                    // TODO: do away with browser targeting
	                    // px adjustments b/c of border&outline
	                    self.rectFill(left + 2, top + 2, width, height);
	                }
	            }
	        });

	        $(_defines2.default.idHashROOT).on(_defines2.default.evHEATMAPCLEAR + namespace, self.erase); // TODO: swap this out

	        // if this image's zoom changed, then change the overlay color
	        $(_defines2.default.idHashROOT).on(_defines2.default.evZOOMCHANGE + namespace, function (e, parms) {
	            if (viewport.getImageId() == parms.imageId) {
	                //viewport.log("heatmap: mag changed: " + viewport.getViewMag());
	                var color = _defines2.default.objectiveColor(viewport.getViewMag());
	                self.fillColorSet(color);
	            }
	        });

	        // user preference update
	        $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSREADY + namespace, function (e, parms) {
	            //debug-only viewport.log("HeatMap us.evUSERPREFSREADY recvd: " + uScope.prefGet(us.CVSHEATMAP));
	            _defines2.default.ENABLEHEATMAP = uScope.prefGet(_defines2.default.CVSHEATMAP);
	        });
	        $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSET + namespace, function (e, parms) {
	            // parms: {className: STR, value: bool}
	            if (parms.className == _defines2.default.CVSHEATMAP) {
	                //debug-only
	                viewport.log('HeatMap us.evUSERPREFSET recvd: ' + uScope.prefGet(_defines2.default.CVSHEATMAP));
	                _defines2.default.ENABLEHEATMAP = parms.value;
	            }
	        });
	        $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFDEFAULTVISIBLE + namespace, function (e, parms) {
	            //debug-only
	            viewport.log('HeatMap us.evUSERPREFDEFAULTVISIBLE recvd: ' + prefVisibleDef);
	            uScope.prefSet(_defines2.default.CVSHEATMAP, prefVisibleDef);
	        });
	    }

	    thumbnailControl.events.on('thumbnail:thumbnail-loaded', function () {
	        construct_();
	    });
	}
	module.exports = exports['default'];

/***/ }

});